export default "__VITE_ASSET__w43f69AI__"